import React from "react";

/**
 * VaultSafe wordmark — uses the supplied SVG files as-is.
 * Do not regenerate or restyle the logo.
 *
 * Props:
 *   variant:
 *     - "light-bg" (navy + blue Safe) — use on white backgrounds       [DEFAULT]
 *     - "dark-bg"  (white + light-blue Safe) — use on navy backgrounds
 *     - "mono-navy" (all navy) — for print/faxes/invoices
 *     - "mono-white" (all white) — for photos, dark bands
 *   width: rendered width in px. The SVG scales proportionally.
 */
export default function Logo({ variant = "light-bg", width = 148, className = "" }) {
  const src = `/vaultsafe-logo-${variant}.svg`;
  // Native aspect ratio of the supplied SVG is 549 × 116.4
  const height = width * (116.4 / 549);
  return (
    <img
      src={src}
      alt="VaultSafe"
      width={width}
      height={height}
      className={className}
      style={{ display: "block" }}
      data-testid="vaultsafe-logo"
    />
  );
}
